export default "__VITE_ASSET__jq4prvf5__"